class Product {
    constructor() {
        this.init();
    }

    init() {
        this.mainArea = document.querySelector('[js-product-main-area]');
        this.bar = document.querySelector('[js-product-bar]');

        this.handleObserver();
    }

    handleObserver() {
        if (!this.bar) return;
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) {
                        this.bar.classList.add('active');
                    } else {
                        this.bar.classList.remove('active');
                    }
                });
            },
            {
                root: null,
                threshold: 0,
                rootMargin: '100px',
            }
        );

        observer.observe(this.mainArea);
    }
}

new Product();

jQuery(function ($) {
    const productPrice = $('[js-product-price]');
    const defaultPriceHtml = productPrice.attr('data-default-price') || productPrice.html();

    const setProductPrice = priceHtml => {
        if (!productPrice.length || !priceHtml) {
            return;
        }

        productPrice.html(priceHtml);
    };

    const resetProductPrice = () => {
        if (!productPrice.length) {
            return;
        }

        productPrice.html(defaultPriceHtml);
    };

    const updateInitialVariationPrice = form => {
        if (!productPrice.length || !form.length) {
            return;
        }

        const variations = form.data('product_variations');
        if (!Array.isArray(variations) || !variations.length) {
            return;
        }

        const selectedAttributes = {};
        let hasUnselectedAttribute = false;

        form.find('select[name^="attribute_"]').each(function () {
            const select = $(this);
            const name = select.attr('name');
            const value = select.val();

            if (!name) {
                return;
            }

            selectedAttributes[name] = value;
            if (!value) {
                hasUnselectedAttribute = true;
            }
        });

        if (hasUnselectedAttribute) {
            return;
        }

        const matchedVariation = variations.find(variation => {
            if (!variation || typeof variation !== 'object' || !variation.attributes) {
                return false;
            }

            return Object.entries(selectedAttributes).every(([attributeName, attributeValue]) => {
                const variationValue = variation.attributes[attributeName];

                return variationValue === '' || variationValue === attributeValue;
            });
        });

        if (matchedVariation && matchedVariation.price_html) {
            setProductPrice(matchedVariation.price_html);
        }
    };

    $(document).on('found_variation', '.variations_form', function (event, variation) {
        if (variation && variation.price_html) {
            setProductPrice(variation.price_html);
        }
    });

    $(document).on('reset_data hide_variation', '.variations_form', function () {
        resetProductPrice();
    });

    // on radio button change(click)
    $(document).on('change', '.js-variation-radios input', function () {
        // for each checked radio button we reflect the same changes to select dropdowns
        $('.js-variation-radios input:checked').each(function (index, element) {
            const radio = $(element);
            const radioName = radio.attr('name');
            const radioValue = radio.attr('value');
            $('select[name="' + radioName + '"]')
                .val(radioValue)
                .trigger('change');
        });
    });

    const getVariationsData = form => {
        const variations = form.data('product_variations');

        if (Array.isArray(variations)) {
            return variations;
        }

        const rawVariations = form.attr('data-product_variations');

        if (!rawVariations) {
            return [];
        }

        try {
            const parsed = JSON.parse(rawVariations);

            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            return [];
        }
    };

    const applySingleVariationSelection = ($form, targetVariation) => {
        if (!targetVariation?.attributes) {
            return false;
        }

        Object.entries(targetVariation.attributes).forEach(([name, value]) => {
            if (!value) {
                return;
            }

            const select = $form.find(`select[name="${name}"]`);

            if (select.length) {
                select.val(value);
            }

            $form
                .find(`.js-variation-radios input[name="${name}"][value="${value}"]`)
                .prop('checked', true);
        });

        if (targetVariation.variation_id) {
            $form.find('input.variation_id').val(String(targetVariation.variation_id));
        }

        $form.find('select[name^="attribute_"]').trigger('change');
        $form.trigger('check_variations');
        $form.trigger('found_variation', [targetVariation]);
        $form
            .find('.woocommerce-variation-add-to-cart')
            .removeClass('woocommerce-variation-add-to-cart-disabled');
        $form.find('.single_add_to_cart_button').removeClass('disabled wc-variation-selection-needed');

        updateInitialVariationPrice($form);

        return true;
    };

    const autoSelectSingleVariation = form => {
        const $form = form instanceof jQuery ? form : jQuery(form);

        if (!$form.length) {
            return false;
        }

        const variations = getVariationsData($form);

        if (!variations.length) {
            return false;
        }

        let targetVariation = null;

        if (variations.length === 1) {
            targetVariation = variations[0];
        } else {
            const selects = $form.find('select[name^="attribute_"]');
            let hasOnlySingleOptions = selects.length > 0;

            selects.each(function () {
                const options = $(this)
                    .find('option')
                    .filter(function () {
                        return $(this).val() !== '';
                    });

                if (options.length !== 1) {
                    hasOnlySingleOptions = false;
                }
            });

            if (hasOnlySingleOptions) {
                targetVariation =
                    variations.find(
                        variation => variation.is_in_stock && variation.is_purchasable
                    ) || variations[0];
            }
        }

        return applySingleVariationSelection($form, targetVariation);
    };

    window.mdaAutoSelectSingleVariation = autoSelectSingleVariation;

    const initVariationForm = form => {
        const $form = form instanceof jQuery ? form : jQuery(form);

        if (!$form.length) {
            return;
        }

        autoSelectSingleVariation($form);
        updateInitialVariationPrice($form);
    };

    $('.variations_form').each(function () {
        initVariationForm($(this));
    });

    $(document.body).on('wc_variation_form', '.variations_form', function () {
        initVariationForm($(this));
    });

    $(document).on('submit', 'form.cart', function (event) {
        if (!document.body.classList.contains('single-product')) {
            return;
        }

        if (!window.mdaMinicart) {
            return;
        }

        event.preventDefault();
        window.mdaMinicart.addFromProductForm(this);
    });
});
